import React from 'react';
import Header from '../../containers/HeaderAdmin.container';
import styles from './styles.module.css';

const HeaderFooterLayout = ({ children }) => {
  return (
    <div className={styles.templateWrapper}>
      <Header />
      <div className={styles.mainWrapper}>
        <div className={styles.content}>{children}</div>
      </div>
    </div>
  );
};

export default HeaderFooterLayout;
